import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// To regenerate from source svgs in src/UILibrary/icons/svgs/*.svg
// run make generate-icons
import { NessieThemeColors } from "src/UILibrary/theme";
import { Box } from "UILibrary";
type CheckIconProps = React.SVGProps<SVGSVGElement> & {
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
  customSize?: string;
  color?: NessieThemeColors;
  onClick?: () => void;
  cursor?: React.CSSProperties["cursor"];
  display?: React.CSSProperties["display"];
  "data-test-name"?: string;
};

const CheckIcon: React.FC<CheckIconProps> = ({
  size = "m",
  color = "inherit",
  customSize,
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ...props
}) => {
  const sizeInPixels = customSize ? customSize : SIZES[size];
  return (
    <Box
      data-test-name={dataTestName}
      onClick={onClick}
      display={display}
      color={color}
      cursor={cursor}
      fontSize={sizeInPixels}
      lineHeight={0}
      position="relative"
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.075 4.925c-3.9-3.9-10.21-3.9-14.15 0-3.9 3.9-3.9 10.21 0 14.15 3.9 3.9 10.21 3.9 14.15 0 3.9-3.94 3.9-10.25 0-14.15zm-2.21 4.02l-5.669 7.437c-.201.241-.442.362-.764.402h-.04a.99.99 0 01-.764-.362l-2.412-2.854a1.122 1.122 0 01-.241-.724c.04-.241.16-.482.362-.683.402-.322 1.045-.282 1.367.12l1.648 1.93 4.944-6.432c.322-.402.965-.483 1.367-.201.201.16.322.402.362.643.04.241 0 .523-.16.724z"
          />
          <mask
            id="CheckIcon_svg__a"
            maskUnits="userSpaceOnUse"
            x={2}
            y={2}
            width={20}
            height={20}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.075 4.925c-3.9-3.9-10.21-3.9-14.15 0-3.9 3.9-3.9 10.21 0 14.15 3.9 3.9 10.21 3.9 14.15 0 3.9-3.94 3.9-10.25 0-14.15zm-2.21 4.02l-5.669 7.437c-.201.241-.442.362-.764.402h-.04a.99.99 0 01-.764-.362l-2.412-2.854a1.122 1.122 0 01-.241-.724c.04-.241.16-.482.362-.683.402-.322 1.045-.282 1.367.12l1.648 1.93 4.944-6.432c.322-.402.965-.483 1.367-.201.201.16.322.402.362.643.04.241 0 .523-.16.724z"
            />
          </mask>
        </svg>
      }
    </Box>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
export default CheckIcon;
